export const orders = {
  m1Title: "Εισερχόμενος Έλεγχος & Αξιολόγηση Ζημιών",
  m1DataProducedHeading: "Παραγόμενα δεδομένα",
  m1ServiceComponentsHeading: "Ταυτότητα εξαρτήματος υπηρεσίας",
  m1ServiceComponentsHint:
    "Καταγράψτε τον σειριακό αριθμό εξαρτήματος ή μονάδας για όλη την υπηρεσία.",
  m1AddComponent: "Προσθήκη εξαρτήματος",
  m1RemoveComponent: "Αφαίρεση",
  m1NoComponents: "Προσθέστε τουλάχιστον ένα εξάρτημα υπηρεσίας.",
  m1ComponentSerialLabel: "Σειριακός αριθμός εξαρτήματος {index}",
  m1SerialLabel: "Σειριακός αριθμός μονάδας",
  m1SerialPlaceholder: "Εισαγάγετε σειριακό αριθμό",
  m1EvidenceDimensional: "Διαστάσεις μετρήσεων",
  m1EvidenceNdt: "Αναφορές μη καταστροφικού ελέγχου (NDT)",
  m1EvidenceVisual: "Εικόνες οπτικού ελέγχου",
  m1FormatPdf: "PDF",
  m1FormatImage: "Εικόνα",
  m1FormatText: "Κείμενο",
  m1SensitivityLabel: "Ευαισθησία",
  m1SensitivityConfidential: "Εμπιστευτικό",
  m1SensitivityIp: "IP",
  m1TextNotesLabel: "Σημειώσεις",
  m1TextNotesPlaceholder: "Προαιρετικό κειμενικό τεκμήριο",
  m1UploadHint: "Σύρετε αρχεία ή κάντε κλικ για μεταφόρτωση",
  m1Uploading: "Μεταφόρτωση…",
  m1UploadFailed: "Η μεταφόρτωση απέτυχε. Δοκιμάστε ξανά.",
  m1RemoveAttachment: "Αφαίρεση αρχείου",
  m1SaveProgress: "Αποθήκευση προόδου",
  m1CompleteMilestone: "Ολοκλήρωση ορόσημου 1",
  m1SavedToast: "Η πρόοδος M1 αποθηκεύτηκε.",
  m1CompletedToast: "Το M1 ολοκληρώθηκε.",
  m1ValidationNoFindings: "Προσθέστε τουλάχιστον ένα εξάρτημα υπηρεσίας.",
  m1ValidationNoComponents: "Προσθέστε τουλάχιστον ένα εξάρτημα υπηρεσίας.",
  m1ValidationSerialRequired:
    "Κάθε εξάρτημα υπηρεσίας χρειάζεται σειριακό αριθμό.",
  m1ValidationComponentRequired:
    "Κάθε εξάρτημα υπηρεσίας χρειάζεται σειριακό αριθμό.",
  m1ValidationEvidenceRequired:
    "Ο εισερχόμενος έλεγχος χρειάζεται τεκμήριο σε τουλάχιστον ένα τμήμα.",
  m2Title: "Ολοκλήρωση Επισκευής / Ανακατασκευής",
  m2PurposeHeading: "Σκοπός δεδομένων",
  m2PurposeQualityAssurance: "Διασφάλιση ποιότητας",
  m2PurposeInternalTraceability: "Εσωτερική ιχνηλασιμότητα",
  m2PostRepairMeasurements: "Μετρήσεις μετά την επισκευή",
  m2HeatTreatmentReferences: "Αναφορές θερμικής επεξεργασίας",
  m2ProcessConfirmation:
    "Επιβεβαίωση διαδικασίας (χωρίς λεπτομερείς παραμέτρους)",
  m2SaveProgress: "Αποθήκευση προόδου",
  m2CompleteMilestone: "Ολοκλήρωση ορόσημου 2",
  m2SavedToast: "Η πρόοδος M2 αποθηκεύτηκε.",
  m2CompletedToast: "Το M2 ολοκληρώθηκε.",
  m2ValidationPostRepairMeasurementsRequired:
    "Προσθέστε τεκμήριο μετρήσεων μετά την επισκευή.",
  m2ValidationHeatTreatmentReferencesRequired:
    "Προσθέστε τεκμήριο αναφοράς θερμικής επεξεργασίας.",
  m2ValidationProcessConfirmationRequired:
    "Προσθέστε τεκμήριο επιβεβαίωσης διαδικασίας.",
  m3Title: "Τελικός Έλεγχος & Ετοιμότητα Πιστοποίησης",
  m3FinalInspectionReport: "Αναφορά τελικού ελέγχου",
  m3ServiceCompletionCopy:
    "Αυτό το ορόσημο αντιπροσωπεύει την ολοκλήρωση υπηρεσίας όταν υπάρχει η τελική αναφορά ελέγχου.",
  m3ServiceCompletionConfirmLabel:
    "Ναι, αυτό το ορόσημο αντιπροσωπεύει ολοκλήρωση υπηρεσίας.",
  serviceCompletionMarkHeading:
    "Σημειώστε αυτό το ορόσημο ως ολοκλήρωση υπηρεσίας",
  m3SaveProgress: "Αποθήκευση προόδου",
  m3CompleteMilestone: "Ολοκλήρωση ορόσημου 3",
  m3SavedToast: "Η πρόοδος M3 αποθηκεύτηκε.",
  m3CompletedToast: "Το M3 ολοκληρώθηκε.",
  m3ValidationFinalInspectionReportRequired:
    "Προσθέστε τεκμήριο τελικής αναφοράς ελέγχου.",
  m3ValidationServiceCompletionRequired:
    "Επιβεβαιώστε ότι αυτό το ορόσημο αντιπροσωπεύει ολοκλήρωση υπηρεσίας.",
  m3FollowUpMilestoneCopy:
    "Η υπηρεσία συνεχίζεται μετά από αυτό το ορόσημο. Ονομάστε το επόμενο ορόσημο παρακάτω και ολοκληρώστε το ορόσημο 3.",
  m3FollowUpMilestoneHint:
    "Μπορείτε να ονομάσετε το επόμενο ορόσημο εδώ ή να συνεχίσετε μετά την ολοκλήρωση του ορόσημου 3.",
  followUpMilestoneHeading: "Επόμενο ορόσημο ({key})",
  followUpMilestoneHint:
    "Μπορείτε να ονομάσετε τον διάδοχο του ορόσημου {number} εδώ ή να συνεχίσετε μετά την ολοκλήρωσή του.",
  followUpMilestoneDescription:
    "Ονομάστε αυτό το ορόσημο και επιβεβαιώστε αν ολοκληρώνει την υπηρεσία.",
  followUpServiceCompletionCopy:
    "Αν δεν επιλεγεί, θα προστεθεί επόμενο ορόσημο μετά από αυτό.",
  followUpDefaultTitle: "Ορόσημο {number}",
  followUpValidationTitleRequired: "Εισαγάγετε όνομα για αυτό το ορόσημο.",
  followUpValidationSectionRequired:
    "Προσθέστε τουλάχιστον ένα πεδίο τεκμηρίωσης με ετικέτα και τεκμήριο (σημειώσεις ή αρχεία).",
  followUpValidationSectionEvidenceRequired:
    "Προσθέστε σημειώσεις ή αρχεία για αυτό το πεδίο τεκμηρίωσης.",
  followUpValidationSectionLabelRequired:
    "Εισαγάγετε ετικέτα πεδίου και επιβεβαιώστε την πριν προσθέσετε τεκμήριο.",
  milestoneNameLabel: "Όνομα ορόσημου",
  milestoneNamePlaceholder: "Εισαγάγετε τίτλο ορόσημου",
  followUpSectionsHeading: "Πεδία τεκμηρίωσης",
  followUpAddSection: "Προσθήκη πεδίου τεκμηρίωσης",
  followUpSectionLabel: "Ετικέτα πεδίου {index}",
  followUpSectionLabelPlaceholder: "π.χ. Αντικατάσταση εξαρτήματος",
  followUpSectionConfirmLabelAria: "Επιβεβαίωση ετικέτας πεδίου",
  followUpSectionEditLabelAria: "Επεξεργασία ετικέτας πεδίου",
  followUpRemoveSection: "Αφαίρεση πεδίου τεκμηρίωσης",
  followUpNoSectionsHint:
    "Προσθέστε πεδίο τεκμηρίωσης για κείμενο, PDF, εικόνες και άλλα τεκμήρια.",
  milestoneSaveProgress: "Αποθήκευση προόδου",
  milestoneCompleteNumber: "Ολοκλήρωση ορόσημου {number}",
  milestoneCompleteService: "Ολοκλήρωση υπηρεσίας",
  milestoneSavedToast: "Η πρόοδος ορόσημου {number} αποθηκεύτηκε.",
  milestoneCompletedToast: "Το ορόσημο {number} ολοκληρώθηκε.",
  milestoneEditTitleAria: "Επεξεργασία ονόματος ορόσημου",
  milestoneSaveTitleAria: "Αποθήκευση ονόματος ορόσημου",
  milestoneCancelTitleAria: "Ακύρωση επεξεργασίας ονόματος",
  milestoneTitlePlaceholder: "Όνομα ορόσημου",
  milestoneStatusPending: "Εκκρεμεί",
  milestoneStatusInProgress: "Σε εξέλιξη",
  milestoneStatusCompleted: "Ολοκληρώθηκε",
  m1GearUnitsDocumented: "{count} τεκμηριωμένο/α εξάρτημα/τα υπηρεσίας",
  milestoneEvidenceDocumented: "{count} τεκμηριωμένο/α τμήμα/τα τεκμηρίων",
  ordersReceivedSaveError: "Αποτυχία αποθήκευσης ορόσημου.",
  ordersReceivedMilestoneError: "Αποτυχία ενημέρωσης ορόσημων.",
  dppEyebrow: "Ψηφιακό Διαβατήριο Προϊόντος",
  dppIntro:
    "Αυτό το διαβατήριο συνδυάζει τα δεδομένα υπηρεσίας ανακατασκευής από όλα τα ολοκληρωμένα ορόσημα.",
  dppBatteryIntro:
    "Διαβατήριο μπαταρίας ευθυγραμμισμένο με την ΕΕ, με επαληθευμένη ταυτότητα, απόδοση, βιωσιμότητα και συμμόρφωση για αυτό το asset.",
  dppBatteryPassportBadge: "Διαβατήριο μπαταρίας",
  dppLastUpdated: "Τελευταία ενημέρωση",
  dppHeroPassportId: "ID διαβατηρίου",
  dppHeroBatteryId: "ID μπαταρίας",
  dppHeroManufacturer: "Κατασκευαστής",
  dppHeroChemistry: "Χημεία",
  dppHeroEnergy: "Ενέργεια",
  dppHeroMass: "Μάζα",
  dppHeroCarbonClass: "Κλάση άνθρακα",
  dppHeroStateOfEnergy: "Κατάσταση ενέργειας",
  dppHeroStatus: "Κατάσταση",
  dppCarbonFootprintHeading: "Βιωσιμότητα",
  dppCarbonBreakdownTitle: "Ανάλυση αποτυπώματος άνθρακα",
  dppCarbonIntensity: "Ένταση",
  dppAttachment: "Συνημμένο",
  dppTampered: "Παραποιημένο",
  dppTamperedBanner:
    "Ένα ή περισσότερα πεδία του διαβατηρίου έχουν επισημανθεί ως παραποιημένα.",
  dppYes: "Ναι",
  dppNo: "Όχι",
  dppGearboxPassportBadge: "Διαβατήριο κιβωτίου",
  dppGearboxIntro:
    "Διαβατήριο ανακατασκευασμένου κιβωτίου ανεμογεννήτριας με ταυτότητα, αποδέσμευση ποιότητας, εύρος παράδοσης και ιχνηλασιμότητα.",
  dppHeroGearboxId: "ID κιβωτίου",
  dppHeroRemanufacturer: "Ανακατασκευαστής",
  dppHeroRatedPower: "Ονομαστική ισχύς",
  dppHeroTurbine: "Ανεμογεννήτρια",
  dppHeroTestResult: "Αποτέλεσμα δοκιμής",
  dppHeroWarranty: "Εγγύηση",
  dppHeroAvailability: "Διαθεσιμότητα",
  dppHeroStock: "Απόθεμα",
  dppGearboxQualityHeading: "Αποδέσμευση ποιότητας",
  dppGearboxQualityTitle: "Έλεγχος και τεκμηρίωση",
  dppGearboxTestRun: "Δοκιμαστική λειτουργία",
  dppGearboxQualityRelease: "Αποδέσμευση",
  dppGearboxInitialInspection: "Αρχική επιθεώρηση",
  dppGearboxConditionAssessment: "Αξιολόγηση κατάστασης",
  dppGearboxFinalInspection: "Τελική επιθεώρηση",
  dppGearboxWarrantyProvided: "Εγγύηση",
  dppGearboxRepairDocs: "Τεκμηρίωση επισκευής",
  dppGearboxTestDocs: "Τεκμηρίωση δοκιμών",
  dppGearboxWarrantyDocs: "Τεκμηρίωση εγγύησης",
  dppGearboxVibration: "Δόνηση",
  dppGearboxTemperature: "Θερμοκρασία",
  dppGearboxLeakage: "Διαρροή",
  dppGearboxIncluded: "Περιλαμβάνεται",
  dppGearboxNotIncluded: "Δεν περιλαμβάνεται",
  dppGearboxDeliveryHeading: "Εύρος παράδοσης",
  dppGearboxExternalAccessories: "Εξωτερικά εξαρτήματα",
  dppGearboxShrinkDisk: "Δίσκος συστολής",
  dppGearboxBrake: "Σύστημα πέδησης",
  dppGearboxRemanHeading: "Ανακατασκευή",
  dppGearboxRemanTitle: "Αρχείο αποδέσμευσης",
  dppGearboxRemanDate: "Ανακατασκευή",
  dppGearboxRemanLocation: "Τοποθεσία",
  dppGearboxFinalCondition: "Τελική κατάσταση",
  dppGearboxReadiness: "Ετοιμότητα",
  dppGearboxLeadTime: "Χρόνος παράδοσης",
  catalogOutcomeReplace: "Αντικατάσταση",
  milestoneRegistryError:
    "Δεν ήταν δυνατή η καταχώριση των εγγράφων του οροσήμου. Το ορόσημο αποθηκεύτηκε.",
  servicePassportUpdatedDimensionsHeading:
    "Ενημερωμένες διαστάσεις εξαρτήματος",
  servicePassportUpdatedDimensionsIntro:
    "Τελευταία μετρημένα μέγιστα μήκος, πλάτος, ύψος και βάρος για αυτή την υπηρεσία.",
  serviceEoiFormTitle: "Εκδήλωση ενδιαφέροντος για αυτή την υπηρεσία",
  serviceEoiFormIntro:
    "Περιγράψτε στον πάροχο το asset και τις προσδοκίες παράδοσης για {{productName}}.",
  serviceEoiAssetDescription: "Περιγραφή asset / εύρους",
  serviceEoiRepairDescription: "Περιγραφή απαιτούμενης επισκευής",
  serviceEoiRepairDescriptionRequired:
    "Περιγράψτε την απαιτούμενη επισκευή για αυτό το αίτημα.",
  serviceEoiDetailsHeading: "Στοιχεία εκδήλωσης ενδιαφέροντος",
  serviceEoiSectionContact: "Πελάτης & εγκατάσταση",
  serviceEoiSectionMachine: "Μηχάνημα & εύρος επισκευής",
  serviceEoiSectionRequirements: "Τεχνικές απαιτήσεις",
  serviceEoiSectionPartAndDelivery: "Διαστάσεις εξαρτήματος & παράδοση",
  serviceEoiCompany: "Εταιρεία",
  serviceEoiPlantLocation: "Τοποθεσία εργοστασίου",
  serviceEoiCountry: "Χώρα",
  serviceEoiContactName: "Υπεύθυνος επικοινωνίας",
  serviceEoiContactEmail: "Email επικοινωνίας",
  serviceEoiContactPhone: "Τηλέφωνο επικοινωνίας",
  serviceEoiTagNumber: "Αριθμός TAG μηχανήματος",
  serviceEoiOemBrand: "Μάρκα OEM",
  serviceEoiMachineModel: "Μοντέλο",
  serviceEoiMachineCategory: "Κατηγορία μηχανήματος",
  serviceEoiMachineType: "Τύπος μηχανήματος",
  serviceEoiMachineSerialNumber: "Σειριακός αριθμός μηχανήματος",
  serviceEoiSectionMachinePart: "Εξάρτημα μηχανήματος",
  serviceEoiPartCategory: "Κατηγορία εξαρτήματος",
  serviceEoiPartTypeKnown: "Ο τύπος του εξαρτήματος είναι γνωστός",
  serviceEoiPartType: "Τύπος εξαρτήματος",
  serviceEoiPartSerialNumber: "Σειριακός αριθμός εξαρτήματος",
  serviceEoiPartAvailableForRefurbishment: "Διαθέσιμο για ανακατασκευή",
  serviceEoiPartCurrentCondition: "Τρέχουσα κατάσταση",
  serviceEoiPartOperatingHours: "Ώρες λειτουργίας",
  serviceEoiPartFailureDescription: "Περιγραφή αστοχίας",
  serviceEoiPartKnownDamage: "Γνωστή ζημιά",
  serviceEoiSectionServiceRequirements: "Απαιτήσεις υπηρεσίας",
  serviceEoiRequestedServiceScope: "Ζητούμενο εύρος υπηρεσίας",
  serviceEoiScopeDescription: "Περιγραφή εύρους",
  serviceEoiAccessoriesIncluded: "Συμπεριλαμβάνονται εξαρτήματα",
  serviceEoiIncludedAccessories: "Συμπεριλαμβανόμενα εξαρτήματα",
  serviceEoiAccessoriesRequiredAfterService:
    "Εξαρτήματα που απαιτούνται μετά την υπηρεσία",
  serviceEoiAccessoryName: "Όνομα εξαρτήματος",
  serviceEoiAddAccessory: "Προσθήκη εξαρτήματος",
  serviceEoiServiceAdditionalRequirements: "Πρόσθετες απαιτήσεις",
  serviceEoiSectionTesting: "Απαιτήσεις δοκιμών",
  serviceEoiRequestedTestRun: "Ζητούμενη δοκιμαστική λειτουργία",
  serviceEoiCustomerSpecificTestRequirements:
    "Ειδικές απαιτήσεις δοκιμών του πελάτη",
  serviceEoiTestReportRequired: "Απαιτείται αναφορά δοκιμών",
  serviceEoiSectionCommercial: "Εμπορικές απαιτήσεις",
  serviceEoiQuotationRequested: "Ζητείται προσφορά",
  serviceEoiWarrantyRequested: "Ζητείται εγγύηση",
  serviceEoiWarrantyRequirements: "Απαιτήσεις εγγύησης",
  serviceEoiYes: "Ναι",
  serviceEoiNo: "Όχι",
  serviceEoiMaterialsHeatTreatment: "Υλικά / θερμική επεξεργασία",
  serviceEoiStandardsCodes: "Πρότυπα ή κώδικες",
  serviceEoiNdtRequirements: "Απαιτήσεις NDT",
  serviceEoiAcceptanceCriteria: "Κριτήρια αποδοχής NDT",
  serviceEoiRequestedDelivery: "Ζητούμενη ημερομηνία παράδοσης",
  serviceEoiCustomerReference: "Η αναφορά σας (προαιρετικό)",
  serviceEoiAdditionalNotes: "Πρόσθετες σημειώσεις",
  serviceEoiAttachmentsHeading: "Σχέδια, φωτογραφίες & έγγραφα",
  serviceEoiAttachmentsHint:
    "Μεταφόρτωση PDF, εικόνων, Office ή CAD (προαιρετικό). Έως 20 αρχεία.",
  serviceEoiAttachmentsUploadHint: "Σύρετε αρχεία ή κάντε κλικ",
  serviceEoiAttachmentsUploadFailed: "Η μεταφόρτωση απέτυχε.",
  serviceEoiAttachmentsMax: "Έφτασαν τα μέγιστα συνημμένα.",
  serviceEoiAttachmentsTypeRejected: "Μη αποδεκτός τύπος αρχείου.",
  serviceEoiAttachmentCategoryDrawing: "Σχέδιο",
  serviceEoiAttachmentCategoryPhoto: "Φωτογραφία",
  serviceEoiAttachmentCategoryOther: "Άλλο",
  serviceEoiAttachmentCategory_drawing: "Σχέδιο",
  serviceEoiAttachmentCategory_photo: "Φωτογραφία",
  serviceEoiAttachmentCategory_nameplatePhoto: "Φωτογραφία πινακίδας",
  serviceEoiAttachmentCategory_overviewPhoto: "Φωτογραφία επισκόπησης",
  serviceEoiAttachmentCategory_damagePhoto: "Φωτογραφία ζημιάς",
  serviceEoiAttachmentCategory_conditionReport: "Αναφορά κατάστασης",
  serviceEoiAttachmentCategory_other: "Άλλο",
  serviceEoiSubmit: "Αποστολή ενδιαφέροντος",
  serviceEoiSubmitting: "Αποστολή…",
  serviceEoiPartSizeUnitFor: "Μονάδα για {{dimension}}",
  serviceEoiDrawingsHeading: "Σχέδια & θέση επισκευής",
  serviceEoiDrawingsIntro: "Σχέδια που βοηθούν στην κατανόηση:",
  serviceEoiDrawingsBulletLocation: "τη θέση της επισκευής",
  serviceEoiDrawingsBulletTolerances: "τις απαιτούμενες διαστάσεις ανοχών",
  serviceEoiDrawingsBulletMaxSizes:
    "τα μέγιστα μεγέθη του εξαρτήματος προς επισκευή",
  serviceEoiDrawingsUploadHint: "Σύρετε αρχεία ή κάντε κλικ για μεταφόρτωση",
  serviceEoiRepairLocationNotes: "Σημειώσεις θέσης επισκευής",
  serviceEoiToleranceNotesPlaceholder: "Τιμές ή πρότυπα ανοχών.",
  serviceEoiPhotosAttachmentsHeading: "Φωτογραφίες & λοιπά έγγραφα",
  serviceEoiPhotosAttachmentsHint:
    "Πρόσθετες φωτογραφίες ζημιάς ή έγγραφα (προαιρετικό).",
  customerDeliveryFinalParametersHeading: "Τελικές διαστάσεις εξαρτήματος",
  customerDeliveryFinalParametersIntro:
    "Τα μετρημένα μέγιστα μήκος, πλάτος, ύψος και βάρος που κατέγραψε ο πάροχος πριν την ολοκλήρωση της υπηρεσίας.",
};
